"use client";

import { Play } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Pageheader() {
  const tickerItems = ["UL 508A", "ARC FLASH", "PHENOLIC", "LASER MARKING", "DPM", "INDUSTRIAL"];
  const tickerLoop = [...tickerItems, ...tickerItems, ...tickerItems];
  return <section data-section-id="2223" id="pageheader" className="bg-background text-foreground relative overflow-hidden" style={{
    minHeight: "90vh"
  }}>
      <style>{`
        @keyframes precision-spin {
          from { transform: translate(-50%, -50%) rotate(0deg); }
          to { transform: translate(-50%, -50%) rotate(360deg); }
        }
        @keyframes precision-ticker {
          from { transform: translateX(0); }
          to { transform: translateX(-33.3333%); }
        }
        @keyframes precision-pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.4; transform: scale(0.85); }
        }
        .precision-spin {
          animation: precision-spin 90s linear infinite;
        }
        .precision-ticker {
          animation: precision-ticker 40s linear infinite;
        }
        .precision-pulse {
          animation: precision-pulse 1.6s ease-in-out infinite;
        }
        .precision-stroke {
          -webkit-text-stroke: 1.5px hsl(40 8% 96%);
          color: transparent;
        }
      `}</style>

      {}
      <div className="absolute top-1/2 left-1/2 pointer-events-none precision-spin" style={{
      width: "140vmax",
      height: "140vmax",
      opacity: 0.2,
      zIndex: 0
    }} aria-hidden="true">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_engraving_machinery.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_engraving_machinery.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_engraving_machinery.webp-wvc-sizes" alt="" loading="lazy" decoding="async" className="w-full h-full object-cover" />
      </div>

      {}
      <div className="relative z-10 border-b border-border/40 overflow-hidden">
        <div className="precision-ticker flex whitespace-nowrap py-3" style={{
        width: "max-content"
      }}>
          {tickerLoop.map((item, i) => <span key={i} data-index={i} className="font-mono text-[12px] text-primary px-8 tracking-widest uppercase">
              {item} <span className="text-primary/40 mx-2">/</span>
            </span>)}
        </div>
      </div>

      {}
      <div className="relative z-10 flex flex-col items-center justify-center px-6 sm:px-10 py-20 md:py-28">
        {}
        <div className="w-full max-w-7xl mx-auto flex flex-col items-center">
          <h1 className="font-default font-black uppercase leading-[0.95] tracking-tight text-center" style={{
          fontSize: "clamp(3.5rem, 8vw, 8rem)"
        }}>
            <span className="block text-foreground">INDUSTRIAL</span>
            <span className="block precision-stroke mt-1 md:mt-2" style={{
            transform: "translateX(clamp(20px, 4vw, 60px))"
          }}>
              MARKING SOLUTIONS
            </span>
          </h1>

          {}
          <p className="font-default text-foreground/70 text-center mt-10 md:mt-14 leading-relaxed" style={{
          fontSize: "1.125rem",
          maxWidth: "540px"
        }}>
            We provide high-precision industrial identification, from UL 508A 
            compliant labels to permanent laser engraving. Engineered for 
            durability in the most demanding environments, ensuring your 
            infrastructure remains compliant and clearly marked.
          </p>

          {}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-10 md:mt-12">
            <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 font-default font-semibold uppercase tracking-wider text-sm h-12 px-8 shadow-lg">
              <Link to="/ProductsPage">View Products</Link>
            </Button>
            <Button asChild variant="ghost" size="lg" className="text-foreground hover:bg-foreground/10 hover:text-foreground border border-border font-default font-semibold uppercase tracking-wider text-sm h-12 px-8">
              <Link to="/CapabilitiesPage">
                <Play className="size-4" />
                Our Capabilities
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-6 right-6 md:bottom-8 md:right-10 z-10 flex items-center gap-2">
        <span className="precision-pulse inline-block size-2 bg-primary" />
        <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-foreground/70">
          Certified Quality
        </span>
      </div>
    </section>;
}